<cfp-dropdown
  [icon]="'ellipsis-v'"
  [formControlSize]="'small'"
  [ariaLabel]="'show' | translate"
  class="ms-2 d-print-none cfp-dropdown-options position-absolute d-flex align-items-center"
  [id]="'selectMeasureStatus'"
  [autoClose]="true"
  (closed)="closed.emit()"
  [container]="'body'"
  #dropdown
>
  @if (dropdown.isOpen()) {
    <div #dropdownContent>
      <label for="selectMeasureStatus" class="mb-2 ms-2 fw-bolder">{{ 'status' | translate }}</label>
      @if (!hideDoneMeasuresAndStatus) {
        <cfp-measure-status-action-button
          [selectedStatus]="measure().status"
          [status]="MeasureStatusDTO.DONE"
          [iconStyle]="'measure-status-implemented'"
          (saveStatus)="onSaveStatus($event)"
        />
      }
      <cfp-measure-status-action-button
        [selectedStatus]="measure().status"
        [status]="MeasureStatusDTO.PLANNED"
        [iconStyle]="'measure-status-planned'"
        (saveStatus)="onSaveStatus($event)"
      />
      <cfp-measure-status-action-button
        [selectedStatus]="measure().status"
        [status]="MeasureStatusDTO.OUTOFSCOPE"
        [iconStyle]="'measure-status-outofscope'"
        (saveStatus)="onSaveStatus($event)"
      />
    </div>
  }
</cfp-dropdown>
